import { useQuery } from '@tanstack/react-query'
import { httpClient } from '../../../shared/api/httpClient'
import { useAstreaEnvironment } from '../../../shared/hooks/useAstreaEnvironment'

export function useCourtsQuery() {
  const { urlAstreaPath, isLoading: isEnvironmentLoading } = useAstreaEnvironment()

  return useQuery({
    queryKey: ['robots', 'lawsuit-courts', urlAstreaPath],
    queryFn: async () => {
      const response = await httpClient.get(`${urlAstreaPath}/api/v2/search-params/lawsuit/court`)
      return response.data
    },
    enabled: !isEnvironmentLoading && Boolean(urlAstreaPath),
    staleTime: Infinity,
  })
}

export default useCourtsQuery
